module.exports = __webpack_public_path__ + "static/media/Footer Adornment.e227d87b.svg";